import { Component, OnDestroy, OnInit, input } from '@angular/core';
import { Subscription } from 'rxjs';
import { ZiroIcons } from '../../shared/models/ziro-icons.enum';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'ziro-self-serve-card',
  templateUrl: './self-serve-card.component.html',
  styleUrls: ['./self-serve-card.component.scss'],
  standalone: false,
})
export class SelfServeCardComponent implements OnInit, OnDestroy {
  readonly dataAutomation = input<string>();
  readonly routerLink = input<string>();
  readonly header = input<string>();
  readonly description = input<string>();
  readonly displayBadgePrimary = input(false);
  readonly displayBadgeSecondary = input(false);
  readonly badgeSecondaryCssClass = input('bg-secondary');
  readonly lottieFile = input<string>();

  ziroIcons = ZiroIcons;
  animation: AnimationItem;
  isLottieReady = false;
  animationOptions = {
    speed: 1,
    renderer: 'svg',
    loop: true,
    autoplay: false,
  } as AnimationOptions;

  private _subscriptions = new Subscription();

  constructor() {}

  ngOnInit(): void {
    this.animationOptions = {
      ...this.animationOptions,
      animationData: this.lottieFile(),
    } as AnimationOptions;
    this.isLottieReady = true;
  }

  ngOnDestroy: () => void = () => {
    this._subscriptions.unsubscribe();
  };

  onAnimationCreated(event: AnimationItem): void {
    this.animation = event;
  }

  onMouseOver(): void {
    this.animation?.play();
  }

  onMouseLeave(): void {
    this.animation?.stop();
  }
}
